<template>
    <b-row>
        <b-col md="8">
            <b-form class="form" @submit="search">
                <b-form-input
                    v-model="input"
                    type="text"
                    placeholder="Ricerca"
                    class="searchbar-input"
                >
                    {{input}}
                </b-form-input>
                <div @click.self="search" class="search-button-container" >
                    <ButtonPrimary :text="'Cerca'" class="search-button" />
                </div>
            </b-form>
        </b-col>
        <b-col md="1"></b-col>
        <b-col md="3" style="text-align:right;">
            <b-dropdown v-if="computedCase!='praticheDottore'" right text="Scegliere date" variant="light" ref="dropdown" menu-class="dd-menu" >
                <b-dropdown-form @reset="resetDate()" @submit="filterDate" class="dd-menu">
                    <b-form-group label="Da" label-for="min" class="datefilter-input-top">
                        <b-form-input
                            id="min"
                            v-model="da_data"
                            type="date"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group label="A" label-for="max" >
                        <b-form-input
                            id="max"
                            v-model="a_data"
                            type="date"
                        ></b-form-input>
                    </b-form-group>
                    <div class="d-flex justify-content-between align-items-center dropdown-button-container" >
                        <ButtonPrimary type="submit" :text="'Applica'" class="dropdown-button" />
                        <ButtonSecondary type="reset" :text="'Reset'" class="dropdown-button" />
                    </div>
                </b-dropdown-form>
            </b-dropdown>
        </b-col>
    </b-row>
</template>

<script>
import ButtonPrimary from '@/components/Button-Primary.vue';
import ButtonSecondary from '@/components/Button-Secondary.vue';
import { mixins } from "@/mixins";
export default {
    name: "SearchBar",
    data(){
        return{
            input: "",
            a_data: "",
            da_data: ""
        }
    },
    props: {
        display: String,
        case: String,
        dottore: String
    },
    mixins: [mixins],
    components:{
        ButtonPrimary,
        ButtonSecondary
    },
    computed:{
        computedCase: function(){
            return this.case;
        }
    },
    methods: {
        search: function(event){
            event.preventDefault();
            switch(this.case){
                case "pazienti":
                    this.searchPaziente();
                    break;
                case "pazientiConDottore":
                    this.searchPazienteConDoc();
                    break;
                case "praticheDottore":
                    this.searchPraticheDottore();
                    break;
                case "dottori":
                    this.searchDottori();
                    break;
                case "laboratori":
                    this.searchPratiche();
                    break;
            }
        },
        searchPaziente: function(){
            if(!this.input){
                this.$emit('pazienti', null);
                return;
            }
            this.$axios
            .get(this.$apibase + '/api/pazienti/paziente?search=' + this.input, {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                }
            })
            .then((response)=>{
                let pazienti_senza_cert = response.data.filter(paziente => !paziente.ultima_certificazione);
                let pazienti_con_cert = response.data.filter(paziente => paziente.ultima_certificazione);
                pazienti_con_cert.sort((a, b) => (Date.parse(b.ultima_certificazione) - Date.parse(a.ultima_certificazione)));
                this.$emit('pazienti', pazienti_con_cert.concat(pazienti_senza_cert));
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        searchPazienteConDoc: function(){
            if(!this.input){
                this.$emit('pazienti', null);
                return;
            }
            this.$axios
            .get(this.$apibase + '/api/pazienti/inCura/filter_pazienti_by_dottore/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                },
                params: {
                    dottore: this.dottore,
                    search_term: this.input
                }
            })
            .then((response)=>{
                let pazienti_senza_cert = response.data.filter(paziente => !paziente.ultima_certificazione);
                let pazienti_con_cert = response.data.filter(paziente => paziente.ultima_certificazione);
                pazienti_con_cert.sort((a, b) => (Date.parse(b.ultima_certificazione) - Date.parse(a.ultima_certificazione)));
                this.$emit('pazienti', pazienti_con_cert.concat(pazienti_senza_cert));
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        searchPraticheDottore: function(){
            if(!this.input){
                this.$emit('praticheByDottore', null);
                return;
            }
            this.$axios
            .get(this.$apibase + '/api/pratica/filter_pratiche_by_dottore/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                },
                params: {
                    dottore: this.dottore,
                    search_term: this.input
                }
            })
            .then((response)=>{
                this.$emit('praticheByDottore', response.data);
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        searchDottori: function(){
            this.$axios
            .get(this.$apibase + '/api/users/get_dottori_search/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                },
                params: {
                    search_term: this.input
                }
            })
            .then((response)=>{
                this.$emit('dottori', response.data);
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        searchPratiche: function(){
            var lab = this.$store.getters['getUser'].full_name;
            this.$axios
            .get(this.$apibase + '/api/pratica/search/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                },
                params: {
                    search_term: this.input,
                    lab: lab,
                }
            })
            .then((response)=>{
                this.$emit('pratiche', response.data);
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        closeDD: function(){
            this.$refs.dropdown.hide(true);
        },
        filterDate: function(event){
            event.preventDefault();
            switch(this.case){
                case "pazienti":
                    this.filterDatePazienti();
                    break;
                case "pazientiConDottore":
                    this.filterDatePazienti();
                    break;
                case "praticheDottore":
                    this.filterDatePraticheDottore();
                    break;
                case "dottori":
                    this.filterDateDottori();
                    break;
                case "laboratori":
                    this.filterDatePratiche();
                    break;
            }
        },
        filterDatePazienti: function(){
            if (this.da_data || this.a_data){
                this.$axios
                .get(this.$apibase + '/api/pazienti/paziente/filter_ultima_cert/', {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                    params: {
                        from: this.da_data,
                        to: this.a_data,
                        dottore: this.dottore
                    }
                })
                .then((response)=>{
                    response.data.sort((a, b) => (Date.parse(b.ultima_certificazione) - Date.parse(a.ultima_certificazione)));
                    this.$emit('pazientiFiltrati', response.data);
                    this.closeDD();
                })
                .catch((e)=>{
                    if (e.response.status == 403)
                        this.logout();
                    else
                        alert(e);
                })
            }
            else {
                this.$emit('refreshPazienti');
            }
        },
        filterDatePraticheDottore: function(){
            this.$axios
            .get(this.$apibase + '/api/pratica/filter_date_pratiche_by_doctor/',
                {
                    headers:{
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    },
                    params: {
                        "dottore": this.dottore,
                        "from": this.da_data,
                        "to": this.a_data
                    }
                }
            )
            .then((response) => {
                this.$emit("filterDatePraticheDottore" ,response.data);
                this.closeDD();
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        filterDateDottori: function() {
            this.$axios
            .get(this.$apibase + '/api/users/filter_date_dottori/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                },
                params: {
                    "from": this.da_data,
                    "to": this.a_data
                }
            })
            .then((response)=>{
                this.$emit('dottori', response.data);
                this.closeDD();
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        filterDatePratiche: function() {
            var lab = this.$store.getters['getUser'].full_name;
            this.$axios
            .get(this.$apibase + '/api/pratica/filter_date/', {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                },
                params: {
                    "from": this.da_data,
                    "to": this.a_data,
                    "lab": lab,
                }
            })
            .then((response)=>{
                this.$emit('pratiche', response.data);
                this.closeDD();
            })
            .catch((e) => {
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        resetDate: function() {
            this.da_data = null;
            this.a_data = null;
        }
    }
}
</script>

<style scoped>
    .searchbar-input{
        width: 87%;
    }
    .searchbar-button{
        width: 13%;
    }
    .form {
        display: flex;
    }
    .datefilter-input-top{
        padding-top: 20px;
    }
    .dropdown-button-container{
        padding-top: 20px;
    }
    .dropdown-button{
        height: 30px;
        width: 80px;
        /* margin-right: 20px; */
    }
    .search-button-container{
        width: 13%;
        /* height: 100%; */
        display: contents;
    }
    .search-button{
        height: 40px;
    }
    .dd-menu{
        color: #707070;
    }
    
</style>